import { kfzInputClientEntityDehydrationDefinitions } from '@/features/Sparten/shared/clientDehydration/kfz/conditionalClientRequestDefinitions';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { computed } from 'vue';
import { KfzFahrerResource } from '@/features/Sparten/shared/schema/kfz/clientSchema/clientSchema';

const nonAvailableFields: ConditionalRequestDefinition = {
  if: computed(() => true),
  drop: [
    'meta.hasAnBegleitetenFahrenTeilgenommen',
    // V2-Delta (wie campv2/pkwv2): der V2-Backend-Validator kennt das per-Fahrer-Bool nicht mehr.
    'meta.hasAnSicherheitstrainingTeilgenommen',
    'meta.hasJahreskarteOeffentlicherPersonenverkehr',
    'meta.jahreskarteOeffentlicherPersonenverkehr',
    'meta.hasWohneigentum',
    'meta.wohneigentum',
  ],
};

export const clientInputDehydration: ConditionalRequestDefinition<KfzFahrerResource>[] =
  [...kfzInputClientEntityDehydrationDefinitions, nonAvailableFields];
